export const FLAG_ITINERARY_CLOSURE_ACTIVITY =
  'FLAG_ITINERARY_CLOSURE_ACTIVITY';
export const GET_ITINERARY_CLOSURE = 'GET_ITINERARY_CLOSURE';
export const CLEAR_ITINERARY_CLOSURE = 'CLEAR_ITINERARY_CLOSURE';
